import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  reviewData: null,
  filters: {
    doctor: [],
    patient: [],
  },
};

export const ReviewSlice = createSlice({
  name: "ReviewReducer",
  initialState,
  reducers: {
    setReviewList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
    setPatientComboList: (state, action) => {
      state.filters.patient = action.payload;
    },
    setReviewData: (state, action) => {
      state.reviewData = action.payload;
    },
  },
});

export const { setReviewList, setDoctorComboList, setPatientComboList, setReviewData } =
  ReviewSlice.actions;

export default ReviewSlice.reducer;
